import { useMutation, useQueryClient } from '@tanstack/react-query'
import { sizeCategoryIndexOptions, sizeCategoryStoreMutation } from '$api-client/@tanstack/react-query.gen'
import { CreateSizeCategoryForm, CreateSizeCategorySchema } from '$features/settings/forms/size-category/create'
import { SettingsRoutePath } from '$features/settings/routes/protected'
import { Router } from '$utils/router'
import { NavigableModal } from '$components'
import { ToastHelper, ToastType } from '$components'
import { QueryErrorHelper } from '$utils/query'
import { useNavigate } from 'react-router'

export function CreateSizeCategoryModal() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const handleClose = () => navigate(Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsPetOptionsSizes))

  const { mutate, isPending, error } = useMutation({
    ...sizeCategoryStoreMutation(),
    onSuccess: () => {
      ToastHelper.createSuccess(ToastType.SizeCategory)
      queryClient.invalidateQueries({ queryKey: sizeCategoryIndexOptions().queryKey })
      handleClose()
    },
  })

  const handleSubmit = (values: CreateSizeCategorySchema) => {
    mutate({
      body: {
        name: values.name,
        from_weight_lbs: values.from_weight_lbs,
        to_weight_lbs: values.to_weight_lbs,
      },
    })
  }

  return (
    <CreateSizeCategoryForm
      isLoading={isPending}
      onSubmit={handleSubmit}
      onCancel={handleClose}
      errors={QueryErrorHelper.getQueryValidationErrors(error)}
    >
      <NavigableModal onClose={handleClose}>
        <NavigableModal.Header>
          <NavigableModal.Heading>Add Size</NavigableModal.Heading>
        </NavigableModal.Header>

        <NavigableModal.Content>
          <CreateSizeCategoryForm.Content />
        </NavigableModal.Content>

        <NavigableModal.Footer>
          <CreateSizeCategoryForm.Controls />
        </NavigableModal.Footer>
      </NavigableModal>
    </CreateSizeCategoryForm>
  )
}
